<template>
  <form v-on:submit.prevent class="w-100 row">
    <div class="col-md-5">
      <validated-input
        :type="'select'"
        :name="`type`"
        :validate="{ required: true }"
        label="Type"
        :options="[{ text: 'Update duplicates', value: 1 }]"
        v-model="item.type"
      />
    </div>
    <div class="col-md-5">
      <validated-input
        :name="`value`"
        :validate="{ required: true }"
        label="Value"
        :help-options="{
          content: 'Provide list of fields to match splited by `;`',
          html: true
        }"
        v-model="item.value"
      />
    </div>
    <div class="col-md-2">
      <div style="margin-top: 32px">
        <b-btn @click="submit" v-if="!item.createdAt" variant="primary" :disabled="errors.any() || pending">
          <i class="far fa-spinner-third fa-spin text-white" v-show="pending"></i>
          Save
        </b-btn>
        <delete-button :title="item.value || 'Action'" v-if="item.createdAt" :remove="remove" />
      </div>
    </div>
  </form>
</template>
<script>
export default {
  name: 'ProductConditionForm',
  inject: ['$validator'],
  props: ['defaultItem'],
  data() {
    return {
      item: this.defaultItem || JSON.parse(JSON.stringify({ value: null, type: null, createdAt: null })),
      pending: false
    };
  },
  methods: {
    remove() {
      this.$emit('remove', this.item);
    },
    async submit(e) {
      e.preventDefault();
      await this.$validator.validateAll();
      if (this.errors.any()) {
        console.log('err', this.errors.any());
        return;
      }
      this.$emit('submit', this.item);
      if (!this.defaultItem) Object.assign(this.item, { value: null, type: null });
    }
  }
};
</script>
